import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableSocialAccounts = Loadable({
  loader: function loader() {
    return import('../SocialAccounts.jsx');
  },
  loading: ComponentLoading
});
export default LoadableSocialAccounts;